var waitFor = require("../utils/waitFor");
var util = require("../utils/misc");
var jsCookies = require("js-cookie");

waitFor("body.intranet", function () {
  var deferredPrompt;
  var homescreenPrompt = document.querySelector(".homescreen-add-button");
  var $addBtn = $(".homescreen-add-button .button");
  var $closeBtn = $(".homescreen-add-button .close");

  var homescreenAck = jsCookies.get("posi-homescreen");
  var isPWA =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone;
  if (homescreenAck || isPWA) return;

  $(homescreenPrompt).css("display", "flex");

  function setHomescreenAck() {
    jsCookies.set("posi-homescreen", 1, { expires: 90 });
  }

  window.addEventListener("beforeinstallprompt", function (e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Update UI to notify the user they can add to home screen
    homescreenPrompt.style.display = "block";
  });

  $closeBtn.on("click", function (e) {
    e.preventDefault();
    homescreenPrompt.style.display = "none";
    setHomescreenAck();
  });

  $addBtn.on("click", function (e) {
    e.preventDefault();
    // hide our user interface that shows our A2HS button
    homescreenPrompt.style.display = "none";

    if (deferredPrompt) {
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then(function (choiceResult) {
        deferredPrompt = null;
        setHomescreenAck();
      });
    } else {
      $.featherlight(".homescreen-ios-instructions");
      $(".featherlight").css("background-color", "#333");
      setHomescreenAck();
    }
  });
});
